import { computed, inject, Injectable, Signal } from '@angular/core';
import { Observable } from 'rxjs';

import { SessionStateService } from '@/core/service/session-state.service';
import { ApiResponse } from '@/core/model/api-response';
import { IAuthService } from '@/core/interface/auth-service.interface';
import { AuthHttpService } from '@/core/service/auth-http.service';

/**
 * Facade — delegates to SessionStateService (state) and AuthHttpService (HTTP).
 * Implements IAuthService so the injection token points here.
 * Existing consumers that inject AuthService directly continue to work unchanged.
 */
@Injectable({ providedIn: 'root' })
export class AuthService implements IAuthService {
    private readonly session = inject(SessionStateService);
    private readonly http    = inject(AuthHttpService);

    // ── IAuthService: reactive state ──────────────────────────────────────
    readonly user: Signal<any>            = this.session.user;
    readonly isLoggedIn: Signal<boolean>  = computed(() => this.session.isLoggedIn());

    // ── IAuthService: state mutations ─────────────────────────────────────
    setLoginUser(data: any): void       { this.session.setLoginUser(data); }
    logout(): void                      { this.session.logout(); }
    setMenuItem(data: any[]): void      { this.session.setMenuItem(data); }
    getMenuItem(): any[]                { return this.session.getMenuItem(); }

    // ── IAuthService: HTTP ────────────────────────────────────────────────
    login(data: any): Observable<ApiResponse<any>> { return this.http.login(data); }
    getUser(): Observable<any>                     { return this.http.getUser(); }
    refreshToken(): Observable<any>                { return this.http.refreshToken(); }
    callLogout(): Observable<any>                  { return this.http.callLogout(); }
}
